import React from "react";

import PageHeading from "../../../../../components/PageHeading";
import { SideNavigationLink } from "../../../../../components/SideNavigation";

import { useIsNewNavigation } from "../../../../../api/hooks/defs/navigation";

//page template
import InfoPageTemplate from "../../../../../pageTemplates/InfoPageTemplate";
import { GOALS_SIDE_NAVIGATION_LINKS } from "../../constants";

type OverviewProps = {
	containerRef: React.RefObject<HTMLDivElement>;
	navItems: Array<SideNavigationLink>;
};

const PAGE_TITLE = "Company Goals Overview";

// this is a wrapper to hold the tornado template info for the dashboard page
const Overview = ({ containerRef, navItems }: OverviewProps) => {
	const mainContent = <div ref={containerRef} />;
	const isNewNav = useIsNewNavigation();

	return (
		<div>
			<InfoPageTemplate
				mainContent={mainContent}
				pageTitle={isNewNav ? PAGE_TITLE : "Company Goals"}
				pageHeading={isNewNav ? <PageHeading>{PAGE_TITLE}</PageHeading> : undefined}
				navigationLinks={navItems}
				activeNavigationLinkKey={GOALS_SIDE_NAVIGATION_LINKS[1].key}
			/>
		</div>
	);
};

export default Overview;
